import React, { Component } from 'react';
import { Button } from 'reactstrap';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import { modelOf } from '../../../prop-types';
import CartStore from '../../../store/CartStore';
import Price from '../../product/Price';
import Icon from '../../common/Icon';
import MarkerBadge from '../../common/MarkerBadge';
import globalTranslations from '../../../i18n/globalTranslations';
import NavigationCartPopover from '../NavigationCartPopover';
import RequestState from '../../../types/RequestState';
import AccountStore from '../../../store/AccountStore';
import ConfigStore from '../../../store/ConfigStore';
import UIStore from '../../../store/UIStore';
import Analytics from '../../../analytics/Analytics';
import ProductAddedToCardModalType from '../../../types/ProductAddedToCartModalStyle';

@observer
export class NavigationCart extends Component {
  constructor(props) {
    super(props);
    this.cartIsPopover = this.cartIsPopover();
  }

  getPrice = () => {
    const { cartStore, withTax } = this.props;
    return cartStore.cart && cartStore.cart.total.getPrice(withTax);
  };

  getHidePriceOnMobile = () => this.getPrice() > 1000;

  renderPrice = () => {
    const price = this.getPrice();
    return price !== null ? <Price price={price} /> : <Price price={0} />;
  };

  renderCartText = () => {
    const { cartStore } = this.props;
    let text;

    switch (cartStore.state) {
      case RequestState.LOADED:
        if (!cartStore.cart || cartStore.cart.number_of_products === 0) {
          text = <FormattedMessage {...globalTranslations.cartEmptySentence} />;
        } else {
          text = (
            <span>
              <FormattedMessage
                {...globalTranslations.itemCount}
                values={{
                  count: cartStore.cart.number_of_products
                }}
              />{' '}
              {this.renderPrice()}
            </span>
          );
        }
        break;
      case RequestState.LOADING:
      default:
        text = <FormattedMessage {...globalTranslations.loading} />;
        break;
    }

    return text;
  };

  sendAnalyticsCheckoutEvent = () => {
    const { analytics, cartStore, configStore } = this.props;

    if (!configStore.gtm.enabled) {
      return;
    }

    const cartProducts = cartStore.cart.products;
    const actionField = { step: 1, option: 'Move To Checkout' };
    analytics.checkout(cartProducts, actionField);
  };

  cartIsPopover = () => {
    const { accountStore, configStore } = this.props;

    if (!accountStore.account) {
      return null;
    }

    const isRetailer = accountStore.account.is_retailer;
    const modalType = configStore.productAddedToCardModalType;

    return isRetailer || modalType === ProductAddedToCardModalType.POPOVER;
  };

  render() {
    const {
      accountStore,
      configStore,
      cartStore,
      className,
      intl,
      withCheckoutButton,
      wrapperClassName
    } = this.props;

    const { checkout } = configStore;

    const ifProductCatalog = accountStore.isViewOnly;
    if (ifProductCatalog) {
      return null;
    }

    return (
      <div className={classNames('NavigationCart', className)}>
        <div
          className={classNames(
            'NavigationCart__cart-button-wrapper',
            wrapperClassName
          )}
        >
          <Button
            block
            color="primary"
            onClick={() => cartStore.cartModal.toggle(true)}
            disabled={cartStore.state !== RequestState.LOADED}
          >
            <Icon name="shopping-cart" />
            <span
              className={classNames('NavigationCart__cart-text', {
                'NavigationCart__cart-text--hide-on-mobile': this.getHidePriceOnMobile()
              })}
            >
              <span className="NavigationCart__cart-text-desktop">
                {this.renderCartText()}
              </span>
              <span className="NavigationCart__cart-text-mobile">
                {this.renderPrice()}
              </span>
            </span>
          </Button>
          {cartStore.cart &&
            cartStore.cart.number_of_products > 0 && (
              <MarkerBadge className="d-xs-inline d-md-none">
                {cartStore.cart.number_of_products}
              </MarkerBadge>
            )}
        </div>
        {withCheckoutButton && (
          <div className="NavigationCart__checkout-button-wrapper">
            <Button
              block
              color="primary"
              tag="a"
              href={checkout.checkoutPath}
              rel="noopener"
              className="NavigationCart__checkout-button"
              onClick={this.sendAnalyticsCheckoutEvent}
              aria-label={intl.formatMessage(
                globalTranslations.proceedToCheckoutSentence
              )}
            >
              <FormattedMessage
                {...globalTranslations.proceedToCheckoutSentence}
              />
            </Button>
          </div>
        )}
        {this.cartIsPopover && <NavigationCartPopover />}
      </div>
    );
  }
}

NavigationCart.propTypes = {
  accountStore: modelOf(AccountStore).isRequired,
  cartStore: modelOf(CartStore).isRequired,
  configStore: modelOf(ConfigStore).isRequired,
  uiStore: modelOf(UIStore).isRequired,
  analytics: PropTypes.instanceOf(Analytics).isRequired,
  intl: intlShape.isRequired,
  withTax: PropTypes.bool.isRequired,
  className: PropTypes.string,
  withCheckoutButton: PropTypes.bool,
  wrapperClassName: PropTypes.string
};

NavigationCart.defaultProps = {
  withCheckoutButton: false,
  className: ''
};

export default injectIntl(
  inject((stores) => ({
    accountStore: stores.accountStore,
    cartStore: stores.cartStore,
    configStore: stores.configStore,
    uiStore: stores.uiStore,
    analytics: stores.analytics,
    withTax: stores.accountStore.showPricesWithTax
  }))(NavigationCart)
);



// WEBPACK FOOTER //
// ./src/components/header/NavigationCart/index.jsx